import styled from "styled-components";

export const ContentMessageConfirmation = styled.div`
  align-items: center;
  display: flex;
  font-size: 1.4rem;
`;
